import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcHome = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("path", {
  d: "m4 13.504 8-6 8 6v5.5a2 2 0 0 1-2 2h-3.5a1 1 0 0 1-1-1v-2a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1v2a1 1 0 0 1-1 1H6a2 2 0 0 1-2-2v-5.5Z",
  fill: "var(--mds-nav-icon-weak)"
}), /* @__PURE__ */ React.createElement("path", {
  clipRule: "evenodd",
  d: "m12 5.554-8.27 5.964A1.25 1.25 0 1 1 2.27 9.49l8.402-6.06a2.25 2.25 0 0 1 2.657 0l8.403 6.06a1.25 1.25 0 0 1-1.462 2.028L12 5.554Z",
  fill: "var(--mds-nav-icon-accent)",
  fillRule: "evenodd"
})), "IcHome");

export { IcHome };
//# sourceMappingURL=ic-home.js.map
